<template>
  <div class="olderDetailFee">
    <el-row style="margin-top:10px;">
      <div class="content">
        <el-row>
          <!-- 老人信息 -->
          <el-row class="title">
            <el-col :span="24">
              <span class="spam-img">
                <img
                  src="@/assets/beadhouse/juxing.png"
                  alt
                  style="vertical-align:middle;margin:0 10px;"
                />
              </span>
              <span class="span-text">老人信息</span>
            </el-col>
          </el-row>
          <table class="mBottom30">
            <tbody>
              <tr class="tr">
                <td class="tdStyle">老人姓名</td>
                <td colspan="2" class="tdStyle">
                  <el-row style="min-width:140px" >{{oldmanInfo.oldName}}</el-row>
                </td>
                <td class="tdStyle">性别</td>
                <td colspan="2" class="tdStyle">
                  <el-row>{{oldmanInfo.sex}}</el-row>
                </td>
              </tr>
              <tr class="tr">
                <td class="tdStyle">床位号</td>
                <td colspan="2" class="tdStyle">
                  <el-row style="min-width:140px" >{{bedNo}}</el-row>
                </td>
                <td class="tdStyle">身份证号</td>
                <td colspan="2" class="tdStyle">
                  <el-row>{{oldmanInfo.idCardNum}}</el-row>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 缴费日期 -->
          <el-row class="title">
            <el-col :span="24">
              <span class="spam-img">
                <img
                  src="@/assets/beadhouse/juxing.png"
                  alt
                  style="vertical-align:middle;margin:0 10px;"
                />
              </span>
              <span class="span-text">入院日期</span>
            </el-col>
          </el-row>
          <table class="mBottom30">
            <tbody>
              <tr class="tr">
                <td class="tdStyle">入院日期</td>
                <td colspan="2" class="tdStyle">
                  <el-row>
                    <el-date-picker
                      :editable="false"
                      :clearable="false"
                      v-model="dateValue"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :disabled="selectDisabled"
                      placeholder="请选择入院日期"
                    ></el-date-picker>
                  </el-row>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 项目信息 -->
          <el-row class="title">
            <el-col :span="24">
              <span class="spam-img">
                <img
                  src="@/assets/beadhouse/juxing.png"
                  alt
                  style="vertical-align:middle;margin:0 10px;"
                />
              </span>
              <span class="span-text">项目信息</span>
            </el-col>
          </el-row>
          <el-table
            border
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :row-style="{height:'100px'}"
            :span-method="objectSpanMethod"
            class="mBottom30"
            style="width:100%;margin-top:10px;"
          >
            <el-table-column prop="chargeModelName" label="项目类型" min-width="150" align="center"></el-table-column>
            <el-table-column prop="expenseTypeName" label="缴费项目" min-width="150" align="center"></el-table-column>
            <el-table-column prop="itemName" label="缴费子项" min-width="150" align="center"></el-table-column>
            <el-table-column prop="chargeStandard" label="实际费用" min-width="150" align="center"></el-table-column>
            <el-table-column prop="costType" :formatter="formatCostType" label="收费方式" min-width="150" align="center"></el-table-column>
            <!-- <el-table-column
              prop="personCategoryReduceFee"
              label="人员类别减免费用"
              min-width="150"
              align="center"
            ></el-table-column> -->
            <el-table-column label="人工减免费用" min-width="150" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.manualReducefee"
                  :disabled="selectDisabled"
                  auto-complete="off"
                  @blur="changeInputReduceFee(scope.$index,scope.row)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="paymentFee" label="缴费金额" min-width="150" align="center"></el-table-column>
          </el-table>
        </el-row> 
        <div slot="footer" class="footer" align="center">
          <el-button type="warning" plain @click="last">上一步</el-button>
          <el-button type="primary" plain @click="paymentInformation" :disabled="nextDisabled">完成</el-button>
        </div>
      </div>
    </el-row>
  </div>
</template>
<script>
import util from "@/utils/util.js";
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "OlderDetailFee",
  data() {
    return {
      nextDisabled:true,//完成按钮默认不能点击
      status: "", //判断是加载已选择项目的数据源 还是生成缴费单信息的数据源
      disableChangeFlag:false,
      selectDisabled: "", //单选表格的下拉框是否可以选取修改
      isPayed: "", //是否已缴费的状态  0---未缴  1---已缴
      oldmanId: "", //老人id
      bedNo: "", //床位号
      groupId: "", //机构id
      tableData: [], //表格的数据源
      dateValue: util.formatDate.format(new Date(), "yyyy-MM-dd"), //入院日期
      //dateValue:'',//缴费日期
      oldmanInfo: {}, //老人的基本信息
      prepaidCycleNumber: "",// 预缴几个月
      prepaidCycleId: "", //预缴周期id
      prepaidCycleCheck:false,
      olderDetailService:{
        queryExpenseItem:"omc/selectExpense/queryExpenseItem/",//可购买项目查询
        bindExpenseItem:"omc/selectExpense/bindExpenseItem",//已选择项目保存
        showAllBuild:"omc/Building/showAll",//查询该机构所有楼栋
        showAllBed:"omc/Room/showAll",//查询该机构所有床位
        queryBedFee:"omc/selectExpense/matchBedFeeByBedId/",//匹配床位费
        queryCareLevelByOldManId:"cac/CacOldman/queryByOldManId",//已经填写基本信息的老人通过老人id去查询护理等级
        matchCareFeeByCareType:"omc/selectExpense/matchCareFeeByCareType/",//护理费匹配
        queryOldmanExpenseItem:"omc/selectExpense/queryOldmanExpenseItem/",//已选择项目查询
        queryOldManInfo:"omc/selectExpense/getOldmanInfoByOldmanId/",//获取老人的基本信息
        queryAllCycle:"omc/prepaidCycle/queryAll",//预缴周期查询数据
        getCycleDaysByGroupId:"omc/returnFeeConfig/getByGroupId/",//查询配置数据回显
        matchSetMeal:"omc/selectExpense/matchSetMeal/",//查询匹配的套餐
        paymentInformation:"omc/selectExpense/generateOldmanInBill",//入院缴费单生成（武昌福利院）
        queryBedNo:"omc/Bed/selectByBedId",//查询床位
        queryRoom:"omc/Room/selects",//查询房间 
        getAdvisoryBedId:"omc/selectExpense/getAdvisoryBedId/",//获取咨询记录中的床位id
        queryPaidItemByOldmanId:"omc/selectExpense/queryPaidItemByOldmanId/",//查询是否生成了缴费信息
        deleteSelectItemByModelCode:"omc/selectExpense/deleteSelectItemByModelCode",//根据缴费模式码删除已选择项目
        queryCheckInDays:"omc/selectExpense/queryCheckInDays",//缴费周期剩余天数计算
        paymentInformationleyi:"omc/selectExpense/oldmanInOfLeyi",//入院生成缴费单（乐颐社区版）
    },
      cycle: "", //周期
      cycleOptions: [], //周期的数据
      setMeal: "", //套餐id
      newSetMeal: "", //该套餐在套餐管理被禁用之后的 用于套餐传的id
      setMealOptions: [], //套餐的数据
      feeTableList: [
        {
          actualFee: 0,
          personCategoryReduceFee: 0,
          manualReducefee: 0,
          paymentFee: 0,
          actualTotalFee: 0
        }
      ], //费用合计的数据
      cycleMaxDays: "", //周期最大天数
      cycleTotalDays: "", //周期总天数
      payDays: "", //本月剩余天数
      payPercent: "", //本月剩余周期数
      number: "", //处理之后的的周期,用于计算
      itemInfoList: [], //处理的项目的数据  用来筛选套餐 让哪一些套餐显示，哪一些套餐隐藏
      setMealList: [], //套餐项目的数据
      setMealItemVoList: [], //套餐详情的数据
      dealItemInfoList: [], //处理的项目的数据  用来和套餐比较重新计算费用  将周期缴费中的周期数和非周期缴费中的执行频次 减去 套餐中的执行频次times
      newPaymentItemList: [], //添加套餐后的 周期缴费的周期和非周期缴费的执行频次减去了减去了套餐中的执行频次time之后的新的数据
      packageFee: "", //套餐的价格
      toMonthDay: "", //当月实际天数
      hospitalType: "", //判断是hospitalType=1--新增，2--修改和3---入院咨询 和11---接待员待办事项 武昌福利院   还是乐怡社区版hospitalType=4和5
      paymentRecordGenerateConfig: "", //解析的cron表达式的生成缴费周期的值
      itemList: [], //by guo 2019-10-22 15:18 添加  生成缴费单之后重新选取时间后，用来参与实际费用 、 人员类别费用 、人工减免 、预缴周期 、实缴合计的费用的计算
      admissionDatestatus: false, //生成缴费单之后再进来页面 是否修改了入院时间 false---否  true---是
      arrTwoFilterList: [] //用来存放modelCode==2(周期项目)中isFixedPrice==0（金额不固定的）的数据
    };
  },
  methods: {
    formatCostType(row){
      let costTypeY = "";
      switch(row.costType){
        case 1:
          costTypeY = "元/次";
          break;
        case 2:
          costTypeY = "元/天";
          break;
        case 3:
          costTypeY = "元/月";
          break;
        case 4:
          costTypeY = "元/年";
          break;
        case 5:
        costTypeY = "元/年";
          break;
        default:
          costTypeY = "元/一次性";
      }
      return costTypeY;
    },
    /* 
      人工减免的change事件
    */
    changeInputReduceFee(index, row) {
      row.paymentFee = Number(row.chargeStandard) - Number(row.personCategoryReduceFee) - Number(row.manualReducefee);
      if(row.paymentFee <0){
        row.manualReducefee = Number(row.chargeStandard) - Number(row.personCategoryReduceFee);
        row.paymentFee = 0;
      }
    },
    /* 
      已选择项目查询  缴费信息还没生成的时候
    */
    queryOldmanExpenseItem() {
      let oldmanId = this.oldmanId;
      this.tableData = []; //清空数据，防止数据累加  下面同理
      var arrOneList = []; //入院缴费
      var arrTwoList = []; //每月缴费项目
      this.arrTwoFilterList = []; //by guo 2019-10-26 15:51添加 用来存放modelCode==2周期缴费 isFixedPrice==0金额不固定的数据
      this.feeTableList = [
        {
          actualFee: 0,
          personCategoryReduceFee: 0,
          manualReducefee: 0,
          paymentFee: 0,
          actualTotalFee: 0
        }
      ];
      this.$postJson(
        this.olderDetailService.queryOldmanExpenseItem + oldmanId
      ).then(res => {
          if(res.result!=null && res.result.length>0){
            this.status = res.result[0].status;
          }
          if (this.status != 0) {
              //调取生成缴费信息的=
              this.queryBillByOldManId(); // 查询缴费记录单; 页面不可修改
              //t
              this.disableChangeFlag = true;
              // if(res.result[0].isPay == 1){
              //   this.isPayed = 1;
              // }
          }
          setTimeout(()=>{
              this.nextDisabled=false;//by guo 2019-11-2--13:16数据请求成功按钮可以点击
          },20)
          res.result.forEach(item => {
            item.personCategoryReduceFee =
              (item.chargeStandard * item.precent) / 100; //人员类别减免费用
            item.manualReducefee = 0; //人工减免费用
            item.paymentFee = item.chargeStandard * 1; //每一项的实缴金额
            //将数据处理分类显示   在页面上能够很直观的看到消费项目下面的缴费项目有那些
            let chargeConfigObj = {};
            var chargeModelName =
              item.code == 3
                ? "入院收费"
                : item.code < 3
                ? "周期收费"
                : "其他收费";
            item.expenseItemId = item.id;
            //把同一类的数据放在一数组中   1- 入院收费 2-周期收费 3-出院收费 4-非周期收费
            if (item.code == 3) {
              chargeConfigObj = Object.assign({}, item);
              chargeConfigObj.chargeModelName = chargeModelName;
              arrOneList.push(chargeConfigObj);
            } else if (item.code <3) {
              chargeConfigObj = Object.assign({}, item);
              chargeConfigObj.chargeModelName = chargeModelName;
              arrTwoList.push(chargeConfigObj);
              // if (item.isFixedPrice != 0) {
              //   arrTwoList.push(chargeConfigObj);
              // } else {
              //   this.arrTwoFilterList.push(chargeConfigObj);
              // }
            } 
          });
          this.tableData = this.tableData
            .concat(arrOneList)
            .concat(arrTwoList)
          this.getSpanArr(this.tableData);
          //处理匹配套餐的数据
          this.itemInfoList = []; //清空数据，防止累加
          this.dealItemInfoList = []; //清空数据，防止累加
          this.tableData.forEach(temp => {
            let itemObj = new Object();
            // itemObj.id=temp.id;//项目id  by guo 2019-09-11 20:15 修改
            itemObj.id = temp.expenseItemId; //项目的id
            itemObj.modelCode = temp.modelCode; //消费类型
            itemObj.itemName = temp.itemName; //项目名称
            itemObj.chargeStandard = temp.chargeStandard; //实际费用
            itemObj.personCategoryReduceFee = temp.personCategoryReduceFee; //人员类别减免费用
            itemObj.manualReducefee = temp.manualReducefee; //人工减免费用
            itemObj.paymentFee = temp.paymentFee; //缴费金额
            itemObj.precent = temp.precent; //减免比例
            if (temp.code < 3 ) {
              //周期缴费
              itemObj.number = this.number * temp.amount; //处理后的实际缴费周期
            } else {
              //入院缴费  或者  非周期缴费
              itemObj.number = temp.amount;
            }
            this.itemInfoList.push(itemObj); //获取到处理之后的项目数据  用来筛选套餐  哪一些显示， 哪一些隐藏
            this.dealItemInfoList.push(itemObj); //获取到处理之后的项目数据  用来重新计算费用 周期缴费周期数和非周期缴费的执行频次 减去  套餐项目的执行频次
          });
         
      });
      console.log(this.tableData);
    },
    /* 
      *查询是否生成了缴费信息   
      *by guo 用这个新写的  费用合计项里面的实际费用  人员类别减免  人工减免  预缴周期  实缴合计 的数据回显 需要判断是回显那个方法里面的数据
      *生成缴费单后  再次进入这个页面:
          1.不做任何操作 费用合计项的5个费用都是通过这个方法this.queryBillByOldManId()来获取直接回显   
          2.如果操作了入院时间   预缴周期   推荐套餐   都需要动态的去计算显示5个费用  
            2-1.预缴周期和推荐套餐的5个费用的重新计算已经在相应的change函数中做了, 操作入院时间就需要调取此方法this.calculate() 
            来重新计算费用合计项中的5个费用
    */
    queryPaidItemByOldmanId() {
      let oldmanId = this.oldmanId;
      this.tableData = []; //清空数据，防止数据累加  下面同理
      this.$postJson(
        this.olderDetailService.queryPaidItemByOldmanId + oldmanId
      ).then(res => {
        console.log(res);
        this.queryBillByOldManId(); // 查询缴费记录单; 页面不可修改
      });
    },

    /*
     *by guo 2019-10-22 14:17添加
     *获取生成缴费单之后的实际费用 、人员类别见面费用 、人工减免费用 、 预缴费用 、实缴合计
     */
    queryBillByOldManId() {
      let params = new Object();
      params.oldManId = this.oldmanId; //老人id
      params.billType = 1; //账单类型 1.入院账单 2.出院账单 3.调整账单 4.周期账单
      this.feeTableList = [
        {
          actualFee: 0,
          personCategoryReduceFee: 0,
          manualReducefee: 0,
          paymentFee: 0,
          actualTotalFee: 0
        }
      ];
      this.$postJson("omc/bill/queryBillByOldManId", params).then(res => {
        console.log(res);
        if (res.code == 200) {
          if(res.result!=null && res.result.length!=0 && res.result[0].isPay == 1){
            this.selectDisabled = true;
            this.isPayed = 1;
          }else{
            this.nextDisabled=false;
          }
          
          // this.feeTableList[0].actualFee = res.result[0].billInHospitalFee.actualFee.toFixed(2);
          // this.feeTableList[0].personCategoryReduceFee = res.result[0].billInHospitalFee.userTypeRateRefief.toFixed(2);
          // this.feeTableList[0].manualReducefee = res.result[0].billInHospitalFee.userRateRefief.toFixed(2);
          // this.feeTableList[0].paymentFee = res.result[0].billInHospitalFee.lastMonthFee.toFixed(2);
          // this.feeTableList[0].actualTotalFee = res.result[0].billInHospitalFee.totalFee.toFixed(2);
          //inDate
          if(res.result!=null && res.result.length!=0){
            this.dateValue = res.result[0].inDate;
            //查询缴费记录单
            // 回显 tableData并且反选选中的
            this.tableData.forEach(item =>{
              res.result[0].billItemList.forEach(item2=>{
                if(item.id == item2.expenseItemId){
                  item.manualReducefee = item2.userRateRefief;
                  item.paymentFee = item2.actualFee;
                }
              })
            })
          }
        }
      });
    },
    /* 
      获取老人的基本信息
    */
    queryOldManInfo() {
      let oldmanId = this.oldmanId;
      this.setMealList = []; //清空数据，防止累加
      this.setMealItemVoList = []; //清空数据，防止累加
      this.$postJson(
        this.olderDetailService.queryOldManInfo + oldmanId
      ).then(res => {
        console.log(res);
        this.oldmanInfo.oldmanId = res.result.oldmanId;
        this.oldmanInfo.oldName = res.result.oldName;
        this.oldmanInfo.idCardNum = res.result.idCardNum;
        this.oldmanInfo.sex = res.result.sex == 0 ? "男" : "女";
        this.oldmanInfo.bedId = res.result.bedId;
        if (res.result.inDate != null) {
          if(this.status!=0){
            this.dateValue = res.result.inDate;
            
          }
        } 
        if (this.oldmanInfo.bedId != null) {
          this.queryBedNo(this.oldmanInfo.bedId);
        }
      });
    },
    /* 
      根据床位id去查询房间id
    */
    queryBedNo(bedId) {
      let params = new Object();
      params.bedId = bedId;
      console.log(params, "床位id");
      this.$postForm(this.olderDetailService.queryBedNo, params).then(
        res => {
          let roomId = res.result.roomId;
          this.queryRoom(roomId);
        }
      );
    },

    /* 
      根据房间id去查房间和床位信息
    */
    queryRoom(roomId) {
      let params = new Object();
      params.roomId = roomId;
      this.$postForm(this.olderDetailService.queryRoom, params).then(
        res => {
          var roomNo = res.result.roomNo;
          res.result.bedList.forEach(item => {
            if (this.oldmanInfo.bedId == item.bedId) {
              this.bedNo = roomNo + "-" + item.bedNo;
            }
          });
        }
      );
    },
  
   
    /* 
      填完缴费信息录入需要提交的数据
    */
    paymentInformation() {
      //已经确认了 入院记录单; 需要打开的
      if(this.isPayed == 1){
        //已经缴费了
        bus.$emit("close_current_tags");
        return;
      }
      //入院日期
      if (this.dateValue != "") {
        let params = new Object();
        var oldmanPaidExpenseItemList = new Array();
        console.log(this.tableData);
        this.tableData.forEach(item => {
          let itemObj = new Object();
          itemObj.expenseItemId = item.id * 1; //项目的id
          itemObj.userRateRefief = item.manualReducefee * 1; //手工减免
          itemObj.actualFee = item.paymentFee * 1; //减免后实际费用
          itemObj.code = item.code; // 0-常规类别(入院选) 1-床位费 2-护理费 3-入院一次性费用 4-出院一次性费用 5-特殊服务(单项收费)
          //按月缴费 按天缴费 所有这里需要传入costType;
          itemObj.expenseTypeId = item.expenseTypeId;
          itemObj.itemType = item.expenseTypeName;
          itemObj.itemName = item.itemName;
          itemObj.modelCode = 1; //入院收费
          itemObj.itemName = item.itemName;
          itemObj.isFixedPrice = item.isFixedPrice;
          itemObj.isAdjust = item.isAdjust;
          itemObj.itemFee = item.chargeStandard;
          itemObj.costType = item.costType; //2 按天 3 按月
          oldmanPaidExpenseItemList.push(itemObj);
        });
        console.log(oldmanPaidExpenseItemList, "oldmanPaidExpenseItemList");
        params.oldmanId = this.oldmanId * 1; //老人id
        params.oldManInDate = this.dateValue; //入院日期 2018-08-08
        params.oldmanPaidExpenseItemList = oldmanPaidExpenseItemList; //选择的项目集合
          this.$postJson(
            "omc/selectExpense/generateOldmanInBill",
            params
          ).then(res => {
            this.$bus.$emit("changeOldListStatus"); //刷新老人列表的数据
            if (res.code == 200) {
              this.$message({ message: "录入成功,请前往入院记录单确认项目", type: "success" });
              bus.$emit("close_current_tags");
            } else {
              this.$message({ message: res.message, type: "error" });
            }
          });
      } else {
        this.$message({ message: "入院日期不能为空", type: "error" });
      }
    },

    /* 
      上一步
    */
    last() {
      bus.$emit("admissiondetail", "last");
    },
   
    /* 
      处理表格的数据 用于合并表格
    */
    getSpanArr(data) {
      this.spanArr = [0,0]; //重置数据，防止数据累加
      // 入院的type = 3 一次性的费用
      // 周期的type 为 0 1 3
      // 电费也可以作为周期费用 不固定金额 
      // lehuo 
      for (var i = 0; i < data.length; i++) {
        // 判断当前元素与上一个元素是否相同  通过表格中的 modelCode模块的modelCode字段来判断 它们是否是一类
        if (data[i].code == 3) {
          this.spanArr[0] += 1;
        } else {
          this.spanArr[1] += 1;
        }
      }
      console.log(this.spanArr, "this.spanArr");
    },

    /* 
      表格 类别的合并
    */
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //console.log(this.spanArr,"this.spanArr...........................");
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },

    //单选表格的
    queryselect() {
      if (this.isPayed == 1) {
        //isPayed---1  已缴 不可修改
        this.selectDisabled = true;
      } else {
        //isPayed----0  未缴 可修改
        this.selectDisabled = false;
      }
    },

    /* 
      表头的颜色
    */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#fff;color:#6f7075;font-weight: 700;height:100px;";
      }
    }
  },
  /* 注释掉 by guo 2019-09-09 20:46 */
  // created(){
  //   this.oldmanId=sessionStorage.getItem('editOldmanId')
  //   this.groupId=sessionStorage.getItem('groupId');
  // },
  mounted() {
    this.oldmanId = sessionStorage.getItem("editOldmanId"); //获取老人的id
    this.groupId = sessionStorage.getItem("groupId");
    this.queryselect();
    //by  延迟加载 否则无法获取到数据  2019-09-16 16：16 添加
    this.queryOldManInfo();
    //by 延迟加载  否则无法获取到数据 2019-09-16 16:16 添加
    this.queryOldmanExpenseItem(); //放在这里面调,不能放在生命周期钩子函数中调 要保证this.cycleMaxDays和this.cycleTotalDays已经存在
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     //this.queryPaidItemByOldmanId();//放在这里面调,不能放在生命周期钩子函数中调 要保证this.cycleMaxDays和this.cycleTotalDays已经存在
    //     // this.queryOldmanExpenseItem(); //放在这里面调,不能放在生命周期钩子函数中调 要保证this.cycleMaxDays和this.cycleTotalDays已经存在
    //     this.queryCheckInDays(this.dateValue); //获取剩余天数
    //   }, 100);
    // });
  },
  
};
</script>
<style lang="scss" scoped>
.olderDetailFee {
  .title {
    height: 54px;
    line-height: 54px;
    background: #f9f7fa;
    border: 1px #f1eff2 solid;
    .span-img {
      height: 54px;
      line-height: 54px;
      margin-left: 10px;
    }
    .span-text {
      height: 54px;
      line-height: 54px;
      font-size: 16px;
    }
  }
  .topstr {
    margin-top: 20px;
    margin-bottom: 20px;
    padding-left: 10px;
    font-size: 14px;
  }
  table {
    width: 100%;
    margin: 10px auto;
    border-collapse: collapse;
    border: 1px solid #cccccc;
  }
  .tr {
    height: 100px;
    text-align: center;
  }
  .tdStyle {
    color: #6f7075;
    font-weight: 700;
    height: 50px;
  }
  td {
    border: 1px solid #cccccc;
  }
  .mBottom30 {
    margin-bottom: 40px;
  }
  .footer {
    padding: 30px 0;
    background: #fff;
  }
}
</style>